import { createContext, useContext } from "react";
import { PAGE_CODE as DEFAULT_PAGE_CODE } from "./page";

/**
 * React context exposing the current page identifier (e.g. "CENA", "MONTAZ").
 * Used by lead-capture components (CallbackForm, QuizDialog) so the same
 * components can be reused on multiple landing pages without changes.
 *
 * Usage:
 *   <PageProvider value="MONTAZ">
 *     <MontazPage />
 *   </PageProvider>
 *
 *   const pageCode = usePageCode();
 */
export const PageContext = createContext(DEFAULT_PAGE_CODE);

export function PageProvider({ value, children }) {
  return <PageContext.Provider value={value}>{children}</PageContext.Provider>;
}

export function usePageCode() {
  return useContext(PageContext);
}
